import gql from 'graphql-tag';

const externalHistoryByRuleKeyQuery = gql`
  query ExternalHistoryByRuleKey(
    $productCode: ID!
    $ruleKey: String!
    $from: String
    $to: String
  ) {
    externalHistoryByRuleKey(
      productCode: $productCode
      ruleKey: $ruleKey
      from: $from
      to: $to
    ) {
      id
      ruleKey
      categoryCode
      changeType
      changedFields
      changedBy
      changedAt
      beforeValue {
        id
        ruleKey
        category
        factName
        priority
        parameters
        description
        actionOnFail
        actionOnNull
        createdAt
        updatedAt
      }
      afterValue {
        id
        ruleKey
        category
        factName
        priority
        parameters
        description
        actionOnFail
        actionOnNull
        createdAt
        updatedAt
      }
    }
  }
`;

export default externalHistoryByRuleKeyQuery;
